

const ProgressCircle = ({ percent = 0 }) => {
  const radius = 26;
  const stroke = 4;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percent / 100) * circumference;

  return (
    <svg
      width="58"
      height="58"
      viewBox="0 0 58 58"
      style={{ transform: "rotate(-90deg)" }}
    >
      {/* Background circle */}
      <circle
        stroke="#e6e6e6"
        fill="transparent"
        strokeWidth={stroke}
        r={normalizedRadius}
        cx="29"
        cy="29"
      />

      {/* Foreground progress circle */}
      <circle
        stroke="#23913B"
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        r={normalizedRadius}
        cx="29"
        cy="29"
        style={{ transition: "stroke-dashoffset 0.35s" }}
      />

      {/* Centered two-line text */}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        transform="rotate(90, 29, 29)"
        dominantBaseline="middle"
      >
        <tspan x="50%" dy="-0.3em" className="font-12 ff-bold" fill="#222">
          {percent}%
        </tspan>
        <tspan x="50%" dy="1.2em" fontSize="7" fill="#666">
          Filled
        </tspan>
      </text>
    </svg>
  );
};

export default ProgressCircle;
